/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsCreateGipReportMutationRequest, AuditReportsCreateGipReportMutationResponse, AuditReportsCreateGipReport400, AuditReportsCreateGipReport401, AuditReportsCreateGipReport403, AuditReportsCreateGipReport500 } from "../models/AuditReportsCreateGipReport";

export function getAuditReportsCreateGipReportUrl() {
  const res = { method: 'POST', url: `/audit-reports/v1/reports/gip/report` as const }
  return res
}

/**
 * @summary Create new report
 * {@link /audit-reports/v1/reports/gip/report}
 */
export async function auditReportsCreateGipReport(data: AuditReportsCreateGipReportMutationRequest, config: Partial<RequestConfig<AuditReportsCreateGipReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsCreateGipReportMutationResponse, ResponseErrorConfig<AuditReportsCreateGipReport400 | AuditReportsCreateGipReport401 | AuditReportsCreateGipReport403 | AuditReportsCreateGipReport500>, AuditReportsCreateGipReportMutationRequest>({ method : "POST", url : getAuditReportsCreateGipReportUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}